import { logD } from "@blacknut/logging/dist";
import { useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom-v5-compat";

const useSpatialNavigationDisabler = () => {
  const location = useLocation();
  const locationRef = useRef<string>();
  const { pause: pauseSpatialNav } = useSpatialNavigation();

  useLayoutEffect(() => {
    return () => {
      if (location.pathname !== locationRef.current) {
        locationRef.current = location.pathname;
        logD("Spatial", "Pause");
        pauseSpatialNav();
      }
    };
  }, [location.pathname, pauseSpatialNav]);
};
export { useSpatialNavigationDisabler };
